var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 31,
    fill: "none",
    viewBox: "0 0 332 317"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#86EE02",
    d: "M.231 91.476V30.448L52.938 0l52.773 30.448v61.028l-52.773 30.448zm226.289 0V30.448L279.227 0 332 30.448v61.028l-52.773 30.448zM0 286.552v-61.028l52.707-30.448 52.773 30.448v61.028L52.707 317zm226.316 0v-61.028l52.707-30.448 52.773 30.448v61.028L279.023 317zM56.991 189.493v-61.022l52.707-30.448 52.773 30.448v61.022l-52.773 30.454zm113.287 0v-61.022l52.707-30.448 52.773 30.448v61.022l-52.773 30.454z"
  })));
};
export default SvgLogo;